import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const Clock = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 8 8"
    fill="none">
    <path
      d="M4 2.76628V4.09961L5 5.09961M7 4.09961C7 4.49358 6.9224 4.88368 6.77164 5.24766C6.62087 5.61164 6.3999 5.94235 6.12132 6.22093C5.84274 6.49951 5.51203 6.72048 5.14805 6.87125C4.78407 7.02201 4.39397 7.09961 4 7.09961C3.60603 7.09961 3.21593 7.02201 2.85195 6.87125C2.48797 6.72048 2.15726 6.49951 1.87868 6.22093C1.6001 5.94235 1.37913 5.61164 1.22836 5.24766C1.0776 4.88368 1 4.49358 1 4.09961C1 3.30396 1.31607 2.5409 1.87868 1.97829C2.44129 1.41568 3.20435 1.09961 4 1.09961C4.79565 1.09961 5.55871 1.41568 6.12132 1.97829C6.68393 2.5409 7 3.30396 7 4.09961Z"
      stroke="#010F55"
      strokeWidth="0.9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Clock;
